import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

const ResetPassword = () => {
    const location = useLocation();
    const history = useHistory();

    const query = new URLSearchParams(location.search);
    const token = query.get('token');
    const email = query.get('email');

    const [password, setPassword] = useState('');
    const [passwordConfirmation, setPasswordConfirmation] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (!token || !email) {
            setError('Invalid or expired reset link.');
        }
    }, [token, email]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== passwordConfirmation) {
            setError('Passwords do not match');
            return;
        }

        setLoading(true);
        setError('');
        setMessage('');

        try {
            const response = await fetch(
                'https://api.passionateworlduniversity.com/api/customer/reset-password',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        token,
                        email,
                        password,
                        password_confirmation: passwordConfirmation,
                    }),
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Failed to reset password');
            }

            setMessage('Password reset successful. Redirecting to login...');

            setTimeout(() => {
                history.push('/login');
            }, 2000);

        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="newsletter-area">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <h3 className="title mb--20">Reset Password</h3>

                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <input
                                    type="password"
                                    placeholder="New Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <input
                                    type="password"
                                    placeholder="Confirm New Password"
                                    value={passwordConfirmation}
                                    onChange={(e) =>
                                        setPasswordConfirmation(e.target.value)
                                    }
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <button className="btn-default" disabled={loading}>
                                    {loading ? 'Resetting...' : 'Reset Password'}
                                </button>
                            </div>

                            {message && (
                                <p className="text-success mt--10">{message}</p>
                            )}

                            {error && (
                                <p className="text-danger mt--10">{error}</p>
                            )}
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
